import { apiConversation } from 'api'
import { ADD_CONVERSATION, SELECT_CONVERSATION, REMOVE_CONVERSATION, REMOVE_ALL_CONVERSATIONS } from '../../types/conversations'
import { addUserTab } from '../tabs'
import { selectUser } from './user'
import { getChannelName } from 'utils/channelsUtils'

export function addConversation(user) {
  return {
    user,
    type: ADD_CONVERSATION,
    userId: user.id,
  }
}

export function selectConversation(userId) {
  return {
    userId,
    type: SELECT_CONVERSATION,
  }
}

export function removeConversation(userId) {
  return {
    userId,
    type: REMOVE_CONVERSATION,
  }
}

export function removeAllConversations() {
  return {
    type: REMOVE_ALL_CONVERSATIONS,
  }
}

export const getUser = (userId) => (dispatch, getState) => {
  const state = getState()
  const curUser = state.cv_users.users.find(u => u.id === userId)
  if (curUser && curUser.id === userId) {
    const channel = getChannelName(curUser.channels)
    dispatch(addConversation(curUser))
    dispatch(addUserTab(userId, channel))
    dispatch(selectUser(userId, channel))
    return ({ status: 200, data: curUser })
  }
  return apiConversation.users.getUser(userId).then((result) => {
    if (result.status === 200) {
      const user = result.data.results
      const channel = getChannelName(result.data.results.channels)
      dispatch(addConversation(user))
      dispatch(addUserTab(user.id, channel))
      dispatch(selectUser(user.id, channel))
    }
    return ({ status: result.status, data: result.data.results })
  }).catch((error, status) => {
    throw error
    //return ({status:error.response.status, type: error.response.data.type})
  })
}
